module.exports = __webpack_public_path__ + "4882e1b9c0979aac6a9ec4dff2f10d5a.MP3";